export const QR_POLL_INTERVAL_MS = 2000
export const QR_DEFAULT_EXPIRE_SECONDS = 300
export const PAY_POLL_INTERVAL_MS = 3000
export const ORDER_PAGE_SIZE = 10
export const WECHAT_OAUTH_BASE = 'https://api.dongbiaodi.cc/bind_admin.php'
export const QR_IMAGE_SERVICE_BASE = 'https://api.qrserver.com/v1/create-qr-code/'
export const QR_IMAGE_SIZE = 200
export const PAY_QR_CANVAS_SIZE = 220
export const FAVORITE_STORAGE_KEY = 'fav_list'

export const ORDER_STATUS = {
  PENDING: 0,
  NOTARIZED: 2,
  COMPLETED: 4,
  CANCELLED: 5
}

export const QR_LOGIN_STATUS = {
  LOADING: 'loading',
  PENDING: 'pending',
  SCANNED: 'scanned',
  EXPIRED: 'expired',
  SUCCESS: 'success',
  ERROR: 'error'
}
